import React, { useState } from "react"
import { DatePicker, Input, Button, Form } from "antd"
import dayjs from "dayjs"
import CustomModal from "src/components/Modal/CustomModal"
import notice from "src/components/Notice"
import SettingPriceService from "src/services/SettingPriceService"

function ModalAddPrice({ open, onCancel, onSuccess }) {
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields()
      const payload = {
        start_time: dayjs(values.start_time).format("YYYY-MM-DD"),
        note: values.note?.trim(),
      }
      setLoading(true)
      const res = await SettingPriceService.createPrice(payload)
      if (res?.message) {
        notice({ msg: "Thêm mới giá bán thành công", isSuccess: true })
        onSuccess?.() // refresh list nếu cần
        onCancel()
      } else {
        notice({ msg: res?.message || "Thêm mới thất bại", isSuccess: false })
      }
    } catch (err) {
      console.error("Validation or API Error", err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <CustomModal
      title="Thêm cấu hình giá mới"
      open={open}
      onCancel={onCancel}
      onOk={handleSubmit}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="start_time"
          label="Ngày áp dụng"
          rules={[{ required: true, message: "Vui lòng chọn ngày áp dụng" }]}
        >
          <DatePicker
            style={{ width: "100%" }}
            format="DD/MM/YYYY"
            disabledDate={current => {
              // Không cho chọn ngày hôm nay hoặc trước đó
              return current && current <= dayjs().endOf("day")
            }}
          />
        </Form.Item>

        <Form.Item
          name="note"
          label="Ghi chú"
          rules={[{ required: true, message: "Vui lòng nhập ghi chú" }]}
        >
          <Input.TextArea rows={3} placeholder="Nhập ghi chú..." />
        </Form.Item>
      </Form>
    </CustomModal>
  )
}

export default ModalAddPrice
